// extracted by mini-css-extract-plugin
module.exports = {"spinner-border":"_kYiN","spinner-border-sm":"__0dZgx","spinner-grow":"WOg7w","spinner-grow-sm":"qfXFA"};